import { render, staticRenderFns } from "./dialogHelp.vue?vue&type=template&id=02b7c4c7&scoped=true&"
import script from "./dialogHelp.vue?vue&type=script&lang=js&"
export * from "./dialogHelp.vue?vue&type=script&lang=js&"
import style0 from "./dialogHelp.vue?vue&type=style&index=0&id=02b7c4c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b7c4c7",
  null
  
)

export default component.exports